export enum DeliveryMethod {
  NEW_POST_OFFICE = 'NEW_POST_OFFICE',
  MANUAL_NOVA_POSHTA = 'MANUAL_NOVA_POSHTA'
}
